
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 56 56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0 0 36.985 0Z","fill":"#E9E9E0"}}),_c('path',{attrs:{"d":"M37.5.15V12h11.849L37.5.15Z","fill":"#D9D7CA"}}),_c('path',{attrs:{"d":"M18.931 19a4.57 4.57 0 1 0 0-9.138 4.57 4.57 0 0 0 0 9.138Z","fill":"#F3D55B"}}),_c('path',{attrs:{"d":"M6.5 39h43V28l-10-9.5L29 30l-5.483-5.483L6.5 39Z","fill":"#26B99A"}}),_c('path',{attrs:{"d":"M48.037 56H7.963A1.463 1.463 0 0 1 6.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463Z","fill":"#14A085"}}),_c('path',{attrs:{"d":"M39.18 47.736v3.896c-.21.265-.444.48-.704.649a4.305 4.305 0 0 1-1.71.649c-.305.048-.607.07-.908.07a4.135 4.135 0 0 1-1.661-.328 3.72 3.72 0 0 1-1.326-.971c-.378-.43-.675-.966-.89-1.613-.213-.647-.32-1.395-.32-2.242s.107-1.593.32-2.235c.215-.643.51-1.178.89-1.606a3.78 3.78 0 0 1 1.333-.978 4.069 4.069 0 0 1 1.654-.335c.547 0 1.057.09 1.53.273.475.183.898.456 1.272.82l-1.135 1.012a1.951 1.951 0 0 0-.752-.574 2.252 2.252 0 0 0-.875-.178c-.337 0-.66.063-.964.19a2.065 2.065 0 0 0-.82.65c-.242.306-.431.699-.567 1.183-.136.484-.21 1.075-.22 1.777.01.684.08 1.276.213 1.777.132.5.314.91.547 1.23.233.319.497.556.793.71.296.156.608.233.937.233.1 0 .234-.007.403-.021a4.91 4.91 0 0 0 .506-.068 3.29 3.29 0 0 0 .485-.13.695.695 0 0 0 .342-.232v-2.488h-1.71v-1.121h3.337ZM28.08 42.924h1.668V53H28.08v-6.932l-2.256 5.605h-1.449l-2.27-5.605V53h-1.668V42.924h1.668l2.994 6.89 2.981-6.89ZM17.668 53H16V42.924h1.668V53Z","fill":"#fff"}})])
          )
        }
      }
    